/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientLMP
 */
export interface PatientLMP {
    /**
     * Unix seconds of the most recent REAL, PAST tracked period start. Null when the patient has no qualifying tracked period in the read window.
     * @type {number}
     * @memberof PatientLMP
     */
    lmp?: number | null;
    /**
     * True iff lmp is a real derived value (never the synthetic 28-day default).
     * @type {boolean}
     * @memberof PatientLMP
     */
    has_data?: boolean;
    /**
     * Unix seconds of the newest tracked entry — lets the UI convey staleness.
     * @type {number}
     * @memberof PatientLMP
     */
    last_tracked_date?: number | null;
}

/**
 * Check if a given object implements the PatientLMP interface.
 */
export function instanceOfPatientLMP(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatientLMPFromJSON(json: any): PatientLMP {
    return PatientLMPFromJSONTyped(json, false);
}

export function PatientLMPFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientLMP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lmp': !exists(json, 'lmp') ? undefined : json['lmp'],
        'has_data': !exists(json, 'has_data') ? undefined : json['has_data'],
        'last_tracked_date': !exists(json, 'last_tracked_date') ? undefined : json['last_tracked_date'],
    };
}

export function PatientLMPToJSON(value?: PatientLMP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lmp': value.lmp,
        'has_data': value.has_data,
        'last_tracked_date': value.last_tracked_date,
    };
}

